export default __webpack_public_path__ + "static/media/allIcon.6dd2182f.svg";